import {MachineType} from '@domain/machine/machine-type.enum';
import {isNil} from 'lodash-es';
import {OverviewMachine} from '../../overview-machine';

export class MachineOverviewList {
  private _id: number;
  private _name: string;
  private _machineType: MachineType;

  public constructor(id: number, name: string, machineType: MachineType) {
    this._id = id;
    this._name = name;
    this._machineType = machineType;
  }

  public get id(): number {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get machineType(): MachineType {
    return this._machineType;
  }

  public static fromJSON(machineJSON: any): MachineOverviewList {
    return isNil(machineJSON) ? null : new MachineOverviewList(machineJSON.id, machineJSON.name, MachineType[`${machineJSON.machineType}`]);
  }

  public static fromOverviewMachine(overviewMachine: OverviewMachine): MachineOverviewList {
    return new MachineOverviewList(overviewMachine.id, overviewMachine.name, overviewMachine.machineType);
  }
}
